export const enum MatchingProfileRow {
  preferredName = 'preferredName',
  pronouns = 'pronouns',
  gender = 'gender',
  faith = 'faith',
  ethnicity = 'ethnicity',
  languages = 'languages',
  bio = 'bio',
  practiceAddress = 'practiceAddress',
  sessionOption = 'sessionOption',
  supportedAgeGroups = 'supportedAgeGroups',
  modalities = 'modalities',
  specialties = 'specialties',
  communityExpertise = 'communityExpertise',
  treatmentApproach = 'treatmentApproach',
  therapeuticStyle = 'therapeuticStyle',
  education = 'education',
  acceptedInsurance = 'acceptedInsurance',
  licenses = 'licenses',
  npi = 'npi',
}
